import React from 'react'
import { ResetStyle, GlobalStyle } from '../../globalStyle'
import './about.css'

export default function AboutPage() {
  return (
    <div>
      <ResetStyle />
      <GlobalStyle />
      <div className="about-container">
        <div class="profile">
          <div class="profile_info">
            A website offer users post any simple thoughts or news whenever you
            want. Also, reviewing other users' post.
          </div>
          <div class="profile_pic"></div>
        </div>
      </div>
    </div>
  )
}
